/* eslint-disable no-magic-numbers */
import { eachDayOfInterval, eachMonthOfInterval, format } from 'date-fns';

export const nth = (d: number) => {
  const dString = String(d);
  const last = +dString.slice(-2);
  if (last > 3 && last < 21) {
    return 'th';
  }
  switch (last % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

export const formatPaymentDate = (dateStr: string) => {
  const date = dateStr.split('T')[0];
  const [year, month, day = '1'] = date.split('-');
  const localDate = new Date(date);
  localDate.setFullYear(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
  localDate.setHours(0, 0, 0);
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  return `${localDate.getDate()}${nth(localDate.getDate())} ${monthNames[localDate.getMonth()]}`;
};

/**
 * Returns an array of objects, one for each date in the given range.
 * Objects contain a human-readable id (YYYY/MM/DD) and label (DD/MM/YYYY) for each date.
 * @param startDate - The start of the date range
 * @param endDate - The end of the date range
 * @param delimiter - the char to use as a delimiter for the date strings. Defaults to '/'
 */
export const getDateKeysInRange = (startDate: Date, endDate: Date, delimiter = '/') => {
  return eachDayOfInterval({ start: startDate, end: endDate }).map(date => ({
    date,
    id: format(date, `yyyy${delimiter}MM${delimiter}dd`),
    label: format(date, `dd${delimiter}MM${delimiter}yyyy`)
  }));
};

/**
 * Returns an array of objects, one for each month in the given range.
 * Objects contain a human-readable id (YYYY/MM/01) and label (01/MM/YYYY) for each date.
 * @param startDate - The start of the date range
 * @param endDate - The end of the date range
 * @param delimiter - the char to use as a delimiter for the date strings. Defaults to '/'
 */
export const getMonthKeysInRange = (startDate: Date, endDate: Date, delimiter = '/') => {
  return eachMonthOfInterval({ start: startDate, end: endDate }).map(date => ({
    date,
    id: format(date, `yyyy${delimiter}MM${delimiter}dd`),
    label: format(date, `dd${delimiter}MM${delimiter}yyyy`)
  }));
};
